import React from 'react';
import _ from 'underscore';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Button, Grid, Divider, Segment, Header, Input, Dimmer, Loader } from 'semantic-ui-react';
import moment from 'moment'

import FormsInputsText from '../../forms/inputs/text/forms_inputs_text';
import FormsInputsEmail from '../../forms/inputs/email/forms_inputs_email';
import AdminRolesFormsInputsRadioGroup from '../../forms/inputs/radio/admin_roles'
import FormsInputDropdown from '../../forms/inputs/dropdown';
import CommonUtility from '../../../utils/CommonUtility';
import ListClientSelection from '../client/list_client_selection';
import { USER_TYPE, USER_ROLES } from '../../../constants';
import { getSystemAdminClients } from '../../../actions'

const genderLetterOptions = [
    { text: 'Male', value: 'm' },
    { text: 'Female', value: 'f' }
];

class AdminFormBasicInformation extends React.Component {

    state = {
        openModalSelectCompany: true,
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        filter: 'name',
        query: '',
        clients: []
    }

    componentDidMount(){
        if(this.props.users && this.state.clients.length == 0){
            this.getClients()
        }
    }

    showCompanyDialog(isShow) {
        if (isShow) {
            this.setState({
                ...this.state,
                openModalSelectCompany: true,
            })
        } else {
            this.setState({
                ...this.state,
                openModalSelectCompany: false,
            })
        }
    }

    onSelectCompany(companyId, companyName, formikData){
        formikData.setFieldValue("companyName", companyName);
        formikData.setFieldValue("companyCode", companyId)
        this.showCompanyDialog(false);
    }

    getClients = () => {
        const { accessToken } = this.props.users;

        let params = {}

        if (this.state.query !== '') {
            params[this.state.filter] = this.state.query
        }

        getSystemAdminClients({
            accessToken,
            searchPage: this.state.currentPage,
            searchMax: this.state.perPage,
            params
        }, (result, error) => {
            if(result && result.data) {
                if(result.data.pagination) {
                    this.setState({
                        totalPage: result.data.pagination.totalPage,
                        totalData: result.data.pagination.totalData,
                    })
                }
                if(result.data.clients) {
                    this.setState({
                        clients: result.data.clients,
                    })
                }
            }
        });
    }

    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => {
                this.getClients();
            });
        };
    }

    goToNextPage = () => {
        if (this.state.clients.length >= this.state.perPage) {
            this.setState({ currentPage: this.state.currentPage + 1 }, () => {
                this.getClients();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num }, () => {
            this.getClients();
        });
    }

    setPerPage = (num) => {
        this.setState({ perPage: num, currentPage: 1 }, () => {
            this.getClients();
        });
    }

    submitFilter = () => {
        if (this.state.query !== '') {
            this.setState({...this.state, currentPage: 1}, () => {
                this.getClients();
            });
        }
    }

    clearFilter = () => {
        this.setState({ query: '' }, () => {
            this.getClients();
        });
    }

    checkClearFilter = (e) => {
        if(e.target.value == ""){
            this.setState({ query: '' }, () => {
            this.getClients();
        });
        }
        this.setState({ query: e.target.value })
    }

    render() {

        const { user, company } = this.props;
        const isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.admin);
        const isAdminCallCentre = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_CALL_CENTRE], this.props.admin);
        const isAdminCreation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_CREATION], this.props.admin)
        const isAdminIT = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_IT], this.props.admin)

        console.log(user.roles && user.roles.map(role => role.type))
        const ADMIN_OPERATION =  user.roles && user.roles.find(role => role.type === "ADMIN_OPERATION") !== undefined ? true : false
        const ADMIN_ACCOUNT = user.roles && user.roles.find(role => role.type === "ADMIN_ACCOUNT") !== undefined ? true : false
        const ADMIN_CLAIM = user.roles && user.roles.find(role => role.type === "ADMIN_CLAIM") !== undefined ? true : false
        const ADMIN_CALL_CENTRE = user.roles && user.roles.find(role => role.type === "ADMIN_CALL_CENTRE") !== undefined ? true : false
        const ADMIN_IT = user.roles && user.roles.find(role => role.type === "ADMIN_IT") !== undefined ? true : false
        const ADMIN_CREATION = user.roles && user.roles.find(role => role.type === "ADMIN_CREATION") !== undefined ? true : false
        
        
        return (
            <Formik
                enableReinitialize 
                initialValues={{
                    nric: user.nric,
                    name: user.name,
                    email: user.email,
                    password: user.password,
                    birthdate: user.birthdate && moment(user.birthdate).format('YYYY-MM-DD'),
                    effectiveStartDate: user.effectiveStartDate && moment(user.effectiveStartDate).format('YYYY-MM-DD'),
                    effectiveEndDate: user.effectiveEndDate && moment(user.effectiveEndDate).format('YYYY-MM-DD'),
                    gender: user.gender,
                    contactNoCountryCode: user.contactNoCountryCode,
                    contactNo: user.contactNo,
                    created: user.created ? moment(user.created).format('DD/MM/YYYY - HH:mm Z') : "",
                    updated: user.updated ? moment(user.updated).format('DD/MM/YYYY - HH:mm Z') : "",
                    updatedBy: user.updatedBy,
                    version: user.version,
                    ADMIN_OPERATION: ADMIN_OPERATION,
                    ADMIN_ACCOUNT: ADMIN_ACCOUNT,
                    ADMIN_CLAIM: ADMIN_CLAIM,
                    ADMIN_CALL_CENTRE: ADMIN_CALL_CENTRE,
                    ADMIN_IT: ADMIN_IT,
                    ADMIN_CREATION: ADMIN_CREATION
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={this.props.onSubmit}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => {

                    // Show loading UI
                    if(isSubmitting){
                        return ( <Dimmer active inverted><Loader>Loading</Loader></Dimmer>)
                    }

                    return (
                        <Segment>
                            <Form>
                                {console.log(user.roles)}
                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        <Divider horizontal style={{ margin: "13px 0 30px 0" }}> <Header as='h3'>{this.props.submitText}</Header></Divider>
                                    </Grid.Column>

                                    <Grid.Column>
                                        <Field name="name" label="Name" component={FormsInputsText} secondaryLabel="" disabled={!isAdminIT && !isAdminCreation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="email" label="Email" component={FormsInputsText} secondaryLabel="" disabled={!isAdminIT && !isAdminCreation} />
                                    </Grid.Column>
                                    {/* <Grid.Column>
                                        <Field name="password" label="Password" component={FormsInputsText} secondaryLabel="" disabled={!isAdminIT && !isAdminCreation} />
                                    </Grid.Column> */}
                                    <Grid.Column>
                                    <>
                                        <Header sub>Roles</Header>
                                    </>
                                        <Field 
                                            name="ADMIN_OPERATION" 
                                            // checked={}
                                            label="Admin Operation" 
                                            component={AdminRolesFormsInputsRadioGroup} 
                                            secondaryLabel="" 
                                            disabled={!isAdminIT && !isAdminCreation} />
                                        <Field 
                                            name="ADMIN_ACCOUNT" 
                                            // checked={user.roles && user.roles.map(role => role.type === "ADMIN_ACCOUNT" ? true : false)} 
                                            label="Admin Account" 
                                            component={AdminRolesFormsInputsRadioGroup} 
                                            secondaryLabel="" 
                                            disabled={!isAdminIT && !isAdminCreation} />
                                        <Field 
                                            name="ADMIN_CLAIM" 
                                            // checked={user.roles && user.roles.map(role => role.type === "ADMIN_CLAIM" ? true : false)}  
                                            label="Admin Claim" 
                                            component={AdminRolesFormsInputsRadioGroup} 
                                            secondaryLabel="" 
                                            disabled={!isAdminIT && !isAdminCreation} />
                                        <Field 
                                            name="ADMIN_CALL_CENTRE" 
                                            // checked={user.roles && user.roles.map(role => role.type === "ADMIN_CALL_CENTRE" ? true : false)} 
                                            label="Admin Call Centre" 
                                            component={AdminRolesFormsInputsRadioGroup} 
                                            secondaryLabel="" 
                                            disabled={!isAdminIT && !isAdminCreation} />
                                        <Field 
                                            name="ADMIN_IT" 
                                            // checked={user.roles && user.roles.map(role => role.type === "ADMIN_IT" ? true : false)} 
                                            label="Admin IT" 
                                            component={AdminRolesFormsInputsRadioGroup} 
                                            secondaryLabel="" 
                                            disabled={!isAdminIT && !isAdminCreation} />
                                        <Field 
                                            name="ADMIN_CREATION" 
                                            // checked={user.roles && user.roles.map(role => role.type === "ADMIN_IT" ? true : false)} 
                                            label="Admin Creation" 
                                            component={AdminRolesFormsInputsRadioGroup} 
                                            secondaryLabel="" 
                                            disabled={!isAdminIT && !isAdminCreation} />
                                    </Grid.Column>

                                    {(isAdminIT || isAdminCreation) &&
                                        <Grid.Column width={16}>
                                            <Button
                                                loading={isSubmitting}
                                                type="submit"
                                                primary
                                                disabled={isSubmitting}
                                                fluid
                                                size="big"
                                            >
                                                {this.props.submitText}
                                        </Button>
                                        </Grid.Column>
                                    }

                                    <Grid.Column width={16}>
                                        {this.props.renderSubmitResult instanceof Function && this.props.renderSubmitResult()}
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        </Segment>
                    )
                }}
            >

            </Formik>
        )
    }

}

AdminFormBasicInformation.defaultProps = {
    clients: [],
    user: {},
    company: {},
    admin: {},
    onSubmit: undefined,
    showDetail: true,
    renderSubmitResult: undefined,
    submitText: "Save"
}

export default AdminFormBasicInformation;

